// The one address the site gives for reaching the Peer Support Hub team.
export const TEAM_EMAIL = 'peersupporthub@msudenver.onmicrosoft.com';
